export enum DataType {
  Null,
  Object,
  Array,
  Date,
  String,
  Boolean,
  Number
}

export class DataTypeUtil {
  public static getType(data: any): DataType {
    if (data == null) {
      return DataType.Null;
    }
    if (Array.isArray(data)) {
      return DataType.Array;
    }
    else if (data instanceof Date) {
      return DataType.Date;
    }
    else {
      switch (typeof data) {
        case 'object':
          return DataType.Object;
        case 'string':
          return DataType.String;
        case 'boolean':
          return DataType.Boolean;
        case 'number':
          return DataType.Number;
        default:
          return DataType.Null;
      }
    }
  }
}
